import React from 'react'

const PhotoGallery = () => {
    return (
        <div className=''><p className="font-semibold text-lg my-5">What to expect!</p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 md:gap-8 gap-4">
                {[...Array(4)].map((item, i) => (
                    <div key={i} className="h-36 w-full bg-gray-800">
                    </div>
                ))}
            </div></div>
    )
}

export default PhotoGallery